
	import Encyclopedia from '@/component/encyclopedia/encyclopedia.vue'
	import { loadInstanceTranslations, i18n } from '@/model/i18n'
	const messages = {
	"n_contributors": "No contributor | <b>{n}</b> contributor | <b>{n}</b> contributors",
	"search": "Search a page",
	"created_by_x_the_y": "Created by {farmer} on {date}",
	"edited_by_x_the_y": "Edited by {farmer} on {date}",
	"n_views": "{v} views",
	"n_contributions": "{n} contributions",
	"not_found": "The page « {name} » does not exist on the encyclopedia in English.",
	"contributor_create": "You are a contributor 😎 Click Edit to start editing this page",
	"locked": "Finish the chapter to unlock the complete AI",
	"end_edition": "End editing",
	"editing_by_x": "Currently being edited by {0}"
}

	Encyclopedia.options.i18n = { messages: {en: messages }}
	export default Encyclopedia